import React from "react";
import { connect } from "react-redux";

import BootstrapTable from "react-bootstrap-table-next";
import Loader from "../../Loader/Loader.js";
import numeral from "../../../../node_modules/numeraljs/numeral.js";
import {
  MetricTable,
  sortNumeric,
  ComponentWithUrl,
} from "./../../Utils/Utils.js";

function title(cell, row) {
  return (
    <span className="table-content-cell">
      <span className="table-content-cell__media">
        <img
          src={row.thumbnail}
          alt={row.title}
          className="table-content-cell__img"
        />
      </span>
      <span className="table-content-cell__link">{row.title}</span>
    </span>
  );
}

function table_cell_number(cell, row) {
  return <MetricTable {...cell} format={"number"} />;
}

function watched_length(cell, row) {
  const length = Math.round(cell.value * 10);
  return (
    <div className="metric metric--table">
      <span className="metric__primary">
        {numeral(length).format("00:00:00")}
      </span>
    </div>
  );
}

class ContentVimeoVideoViews extends ComponentWithUrl {
  renderTable() {
    const { loading, data } = this.props;

    if (loading) {
      return <Loader minHeight={650} col={"col-12"} />;
    }

    // add unique ids
    data.data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "src",
        text: "Title",
        style: { width: "300px", minWidth: "300px", textAlign: "left" },
        headerAlign: "left",
        formatter: title,
        sort: true,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "140px", minWidth: "140px" },
        formatter: table_cell_number,
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "watched_length",
        text: "Video Starts",
        style: { width: "140px", minWidth: "140px" },
        formatter: watched_length,
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "page_views",
        text: "Page Views",
        style: { width: "140px", minWidth: "140px" },
        formatter: table_cell_number,
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    return (
      <BootstrapTable
        keyField="id"
        data={data.data}
        columns={columns}
        defaultSorted={defaultSorted}
        striped={false}
        hover={false}
        bordered={false}
      />
    );
  }

  render() {
    return <div>{this.renderTable()}</div>;
  }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(ContentVimeoVideoViews);
